function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useLocale, usePrefixCls } from '@byte-design/config';
import { classnames } from '@bydesign-ui/utils';
import React, { useCallback, useState } from 'react';
import { Left, Right } from '../../common/icons';
import { Button } from '../button';
import { Panel } from './components/Panel';

function findIndexById(array, id) {
  for (var i = 0; i < array.length; i++) {
    if (array[i].id === id) {
      return i;
    }
  }

  return -1;
}

export function Transfer(props) {
  var localeSource = useLocale('transfer.source');
  var localeTarget = useLocale('transfer.target');
  var _props$sourceTitle = props.sourceTitle,
      sourceTitle = _props$sourceTitle === void 0 ? localeSource : _props$sourceTitle,
      _props$targetTitle = props.targetTitle,
      targetTitle = _props$targetTitle === void 0 ? localeTarget : _props$targetTitle,
      _props$showSearch = props.showSearch,
      showSearch = _props$showSearch === void 0 ? false : _props$showSearch,
      _props$onSearch = props.onSearch,
      onSearch = _props$onSearch === void 0 ? function (i, v) {
    return v.indexOf(i) >= 0;
  } : _props$onSearch,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      _props$sourceValue = props.sourceValue,
      sourceValue = _props$sourceValue === void 0 ? [] : _props$sourceValue,
      _props$targetValue = props.targetValue,
      targetValue = _props$targetValue === void 0 ? [] : _props$targetValue,
      disableAnimation = props.disableAnimation;

  var _useState = useState(sourceValue.map(function (i) {
    return Object.assign({}, i, {
      checked: !!i.checked,
      disabled: !!i.disabled,
      hidden: false
    });
  })),
      _useState2 = _slicedToArray(_useState, 2),
      sValue = _useState2[0],
      setSValue = _useState2[1];

  var _useState3 = useState(targetValue.map(function (i) {
    return Object.assign({}, i, {
      checked: !!i.checked,
      disabled: !!i.disabled,
      hidden: false
    });
  })),
      _useState4 = _slicedToArray(_useState3, 2),
      tValue = _useState4[0],
      setTValue = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      leftDisabled = _useState6[0],
      setLeftDisabled = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      rightDisabled = _useState8[0],
      setRightDisabled = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      leftSearchValue = _useState10[0],
      setLeftSearchValue = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      rightSearchValue = _useState12[0],
      setRightSearchValue = _useState12[1];

  var cls = classnames(usePrefixCls('transfer'));
  var btnGroupCls = classnames(usePrefixCls('transfer-btn-group'));
  var btnRightCls = classnames(usePrefixCls('transfer-btn-right'));
  var onLeftSearch = useCallback(function (v, direction) {
    if (direction === 'left') {
      setLeftSearchValue(v);
    } else {
      setRightSearchValue(v);
    }

    setSValue(function (value) {
      return value.map(function (i) {
        return Object.assign({}, i, {
          hidden: !onSearch(v, i.value)
        });
      });
    });
  }, []);
  var onRightSearch = useCallback(function (v, direction) {
    if (direction === 'left') {
      setLeftSearchValue(v);
    } else {
      setRightSearchValue(v);
    }

    setTValue(function (value) {
      return value.map(function (i) {
        return Object.assign({}, i, {
          hidden: !onSearch(v, i.value)
        });
      });
    });
  }, []);
  var onRightTransfer = useCallback(function () {
    var moveValue = sValue.filter(function (i) {
      return i.checked;
    }).map(function (i) {
      return Object.assign({}, i, {
        checked: false,
        hidden: !onSearch(rightSearchValue, i.value)
      });
    });
    var newSValue = sValue.filter(function (i) {
      return !i.checked;
    });
    var newTValue = [].concat(_toConsumableArray(tValue), _toConsumableArray(moveValue));
    setSValue(newSValue);
    setTValue(newTValue);
    onChange && onChange(newSValue, newTValue, moveValue, 'right');
    onValueChange && onValueChange(newSValue, newTValue, moveValue, 'right');
    setRightDisabled(true);
  }, [sValue, rightDisabled, tValue, rightSearchValue, onChange, onValueChange]);
  var onLeftTransfer = useCallback(function () {
    var moveValue = tValue.filter(function (i) {
      return i.checked;
    }).map(function (i) {
      return Object.assign({}, i, {
        checked: false,
        hidden: !onSearch(leftSearchValue, i.value)
      });
    });
    var newTValue = tValue.filter(function (i) {
      return !i.checked;
    });
    var newSValue = [].concat(_toConsumableArray(sValue), _toConsumableArray(moveValue));
    setTValue(newTValue);
    setSValue(newSValue);
    onChange && onChange(newSValue, newTValue, moveValue, 'left');
    onValueChange && onValueChange(newSValue, newTValue, moveValue, 'left');
    setLeftDisabled(true);
  }, [tValue, leftDisabled, sValue, leftSearchValue, onValueChange]);
  var onDataChange = useCallback(function (direction, id, checked) {
    if (direction === 'left') {
      setSValue(function (value) {
        var index = findIndexById(value, id);
        var newValue = [].concat(_toConsumableArray(value.slice(0, index)), [Object.assign({}, value[index], {
          checked: checked
        })], _toConsumableArray(value.slice(index + 1)));
        var disabled = true;

        var _iterator = _createForOfIteratorHelper(newValue),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.checked) {
              disabled = false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        setRightDisabled(disabled);
        return newValue;
      });
    } else {
      setTValue(function (value) {
        var index = findIndexById(value, id);
        var newValue = [].concat(_toConsumableArray(value.slice(0, index)), [Object.assign({}, value[index], {
          checked: checked
        })], _toConsumableArray(value.slice(index + 1)));
        var disabled = true;

        var _iterator2 = _createForOfIteratorHelper(newValue),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;

            if (item.checked) {
              disabled = false;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        setLeftDisabled(disabled);
        return newValue;
      });
    }
  }, [tValue, sValue, leftDisabled, rightDisabled]);
  return React.createElement("div", {
    className: cls
  }, React.createElement(Panel, {
    direction: 'left',
    title: sourceTitle,
    showSearch: showSearch,
    search: onLeftSearch,
    data: sValue,
    onChange: onDataChange
  }), React.createElement("div", {
    className: btnGroupCls
  }, React.createElement(Button, {
    className: btnRightCls,
    type: rightDisabled ? 'default' : 'primary',
    size: "xs",
    shape: "square",
    onClick: onRightTransfer,
    disabled: rightDisabled
  }, React.createElement(Right, null)), React.createElement(Button, {
    type: leftDisabled ? 'default' : 'primary',
    size: "xs",
    shape: "square",
    onClick: onLeftTransfer,
    disabled: leftDisabled
  }, React.createElement(Left, null))), React.createElement(Panel, {
    direction: 'right',
    disableAnimation: disableAnimation,
    title: targetTitle,
    showSearch: showSearch,
    search: onRightSearch,
    data: tValue,
    onChange: onDataChange
  }));
}